export type SupportedLocales = "en" | "fr";

export const LANGUAGE_OPTIONS = [
  { value: "en", label: "common:language.english" },
  { value: "fr", label: "common:language.french" },
];
